module.exports = __webpack_public_path__ + "static/assets/cbc9cde18d15545a2967be9f5d7f3db5.png";